package dev.wyns.ventrova.platform

import dev.wyns.ventrova.data.model.PlaceCategory
import dev.wyns.ventrova.data.model.VeganLevel

data class PlaceSuggestion(
    val name: String,
    val address: String,
    val category: PlaceCategory,
    val level: VeganLevel,
    val note: String,
)

/** Receives place suggestions and corrections from users. */
interface SuggestionService {
    suspend fun submit(suggestion: PlaceSuggestion)

    /** Asks to find out what a chip shop fries in, because the app doesn't know. */
    suspend fun requestFryOilCheck(placeId: String)
}

/**
 * Placeholder until the backend exists: suggestions are kept in memory only and are lost when the
 * app closes.
 */
class LocalSuggestionService : SuggestionService {
    private val submitted = mutableListOf<PlaceSuggestion>()
    private val fryOilChecks = mutableSetOf<String>()

    override suspend fun submit(suggestion: PlaceSuggestion) {
        submitted += suggestion
    }

    override suspend fun requestFryOilCheck(placeId: String) {
        fryOilChecks += placeId
    }
}
